import { makeStateStore } from '@playcastdotio/StateStore';

/**
 * Persistence-derived attestation metadata mirrored from host-electron, where it is
 * seeded by the cheap systemGetMachineId reply at playjector ready (no TPM signing).
 * `checkAttestationValidity` (machineIdHelpers) reads this to short-circuit a redundant
 * re-attestation when the persisted attestedUserId already matches the current Clerk user.
 *
 * Main process is the source of truth (replicates on `machineIdAttestationStatusState`).
 * The renderer also updates this locally after a successful attestation for in-process
 * consistency; that write does not propagate back to main (renderer reload re-seeds via IPC).
 */
export type MachineIdAttestationStatus = {
  attestedUserId: string;
  attestedAt: number;
  attestationExpiresAt: number;
};

export const machineIdAttestationStatusState = makeStateStore<MachineIdAttestationStatus | null>(null);
